(function($) {

	$.fn.initOffer = function() {

		var _this = this;

		this
			.find(".item")
			.addClass('preparing')
			.waypoint(function() {
				$(this.element).removeClass('preparing');
			}, {
				offset: function() {
					return Waypoint.viewportHeight() - (100);
				}
			})
		;

		window.setTimeout(function() {
			_this.find(".item").addClass("animated");
		}, 50);

		return this;

	}

})(jQuery);
